import { render, staticRenderFns } from "./postCreate.vue?vue&type=template&id=e98efc46&scoped=true&lang=html&"
import script from "./postCreate.vue?vue&type=script&lang=js&"
export * from "./postCreate.vue?vue&type=script&lang=js&"
import style0 from "./postCreate.vue?vue&type=style&index=0&id=e98efc46&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e98efc46",
  null
  
)

export default component.exports